import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyARR-rQc7R1aETfle6elx4iZWWcKXxt0ao",
  authDomain: "rbu-react-alumni.firebaseapp.com",
  projectId: "rbu-react-alumni",
  storageBucket: "rbu-react-alumni.firebasestorage.app",
  messagingSenderId: "855312083522",
  appId: "1:855312083522:web:c6f43201f0522ca3645bdb",
  measurementId: "G-2P7HYR7ZTE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Enable offline persistence
enableIndexedDbPersistence(db)
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Multiple tabs open, persistence can only be enabled in one tab at a time.');
    } else if (err.code === 'unimplemented') {
      console.warn('The current browser does not support persistence.');
    }
  });

export default app;
